import { useEffect, useState } from "react";
import './ProductSliderMulti.scss';
import { ReactComponent as HeartImg } from './assets/heart.svg';
import { UseInterval } from "./UseInterval";
import { useNavigate } from "react-router-dom";
import newTag from './assets/new.svg'
import { IoCartOutline, IoCheckmark } from "react-icons/io5";
import axios from "axios";
import { useProfile } from "../../Contexts/ProfileContext";
import { useToast } from "../../Contexts/ToastContext";

export function ProductSliderMulti({ slides }) {

    // const [slideXPos, setSlideXPos] = useState(0);
    // const [swichSlides, setSwichSlides] = useState({ transform: `translateX(${0}px)`, transition: 'all 0s linear' });
    const [isHover, setIsHover] = useState(-1)
    // const [activeSmalldots, setActiveSmalldots] = useState(0)

    // let [delay, setDelay] = useState(null);
    const [addingToCart, setAddingToCart] = useState(null);
    const [addingToWishlist, setAddingToWishlist] = useState(null);
    const [addedToCart, setAddedToCart] = useState(null);
    const [addedToWishlist, setAddedToWishlist] = useState(null);
    const [pincode, setPincode] = useState('110001'); // Default pincode

    const navigate = useNavigate();
    const { fetchProfile } = useProfile();
    const { showToast } = useToast();

    console.log('slides - ', slides);
    const imagesToShow = 1
    const [slideXPos, setSlideXPos] = useState(-(imagesToShow - 1));
    const movePercent = (100 / imagesToShow).toFixed(5)
    const [swichSlides, setSwichSlides] = useState({ transform: `translateX(${slideXPos * movePercent}%)`, transition: 'all 0s linear' });
    const [activeSmalldots, setActiveSmalldots] = useState(0)
    let [delay, setDelay] = useState(null);

    console.log('swichSlides - ', swichSlides);

    let [imagesCount, setImagesCount] = useState(null)

    useEffect(() => {
        if (swichSlides.transition === '' && delay === null) {
            console.log('in');
            setSwichSlides({ transform: `translateX(${0}px)`, transition: 'none' });
            setSlideXPos(0)
        }
        else if (swichSlides.transition === '') {
            console.log('in');
            setSwichSlides({ transform: `translateX(${slideXPos * movePercent}%)`, transition: 'none' });
            setDelay(10);
            setSlideXPos(0)
        }
    }, [swichSlides])

    useEffect(() => {
        console.log('delay -- ', delay);
    }, [delay])

    // console.log('check now - ',Object.is(0, 0));



    function swichSlideXPos() {
        console.log('slideXPos - ', slideXPos);
        console.log('images.length - ', imagesCount);

        if (slideXPos === -(imagesCount)) {
            console.log('triggere 1');
            setSwichSlides({ transform: `translateX(${-(imagesToShow - 1) * movePercent}%)`, transition: '' })
            setSlideXPos(-(imagesToShow - 1));
            // setActiveSmalldots(1);
            // setDelay(200)

        }
        else {
            console.log('triggere 3');
            console.log(slideXPos - 1);
            setSwichSlides({ transform: `translateX(${(slideXPos - 1) * movePercent}%)`, transition: 'all 1s linear' });
            setSlideXPos(slideXPos - 1);
            setActiveSmalldots(activeSmalldots + 1);
        }

        console.log('check 2 - ', Object.is(slideXPos, -(imagesCount)), ' - ', Object.is(slideXPos, 0));
        console.log('check fields - ', slideXPos, ' - ', imagesCount, ' - ', slideXPos);

        // if (Object.is(slideXPos, -(imagesCount)) || Object.is(slideXPos, 0)) {
        if (Object.is(slideXPos, -(imagesCount - 1))) {
            console.log('check once - ', slideXPos, ' - ', imagesCount, ' - ', slideXPos);

            setActiveSmalldots(0);
        }
    }

    // let [count, setCount] = useState(0);

    UseInterval(() => {
        // Your custom logic here
        // setCount(count + 1);
        if (delay === 500) {
            setDelay(1500);
        }
        else if (delay === 10) {
            setDelay(1500);
        }
        swichSlideXPos();
    }, delay);

    function handleDelayChange(images) {
        console.log('in handleDelayChange');
        // setIsHover(index)
        setDelay(500);
        setImagesCount(images)
    }

    function unsetHover() {
        console.log('in unsetHover');
        setDelay(null);
        setSwichSlides({ transform: `translateX(${0}px)`, transition: '' })
        setIsHover(-1);
        setActiveSmalldots(0);
    }

    let slideInterval = null;

    const MIN_LOADER_MS = 400;

    // Add to cart function
    const handleAddToCart = async (product, event) => {
        event.stopPropagation(); // Prevent navigation when clicking cart button
        const startedAt = Date.now();
        const productId = product.id;

        try {
            setAddingToCart(productId);

            const isGuest = localStorage.getItem('guestUser') === 'true';
            if (isGuest) {
                const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
                const existingIndex = guestCart.findIndex((item) => String(item.product_id) === String(productId));
                if (existingIndex >= 0) {
                    guestCart[existingIndex].selectedQty = (guestCart[existingIndex].selectedQty || 1) + 1;
                } else {
                    guestCart.push({
                        _id: `guest-cart-${Date.now()}-${productId}`,
                        product_id: productId,
                        urls: product.urls || [],
                        title: product.title || 'Product',
                        price: product.price,
                        brand: product.brand,
                        mrp: product.mrp,
                        selectedSize: 'M',
                        selectedQty: 1,
                        size: { M: 10 },
                        availableSizes: ['M'],
                        availableQuantities: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                        maxStock: 10
                    });
                }
                localStorage.setItem('guestCart', JSON.stringify(guestCart));
                window.dispatchEvent(new CustomEvent('guestCartUpdated'));
                setAddedToCart(String(productId));
                setTimeout(() => setAddedToCart(null), 3000);
                setAddingToCart(null);
                return;
            }

            const token = localStorage.getItem("token");
            if (!token) {
                showToast({
                    message: 'Please login to add items to cart',
                    variant: 'info',
                    action: { label: 'Login', onClick: () => navigate('/auth/login') },
                });
                return;
            }

            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };

            const response = await axios.post(
                `/cart/${productId}`,
                {
                    "selectedSize": "M",
                    "selectedQty": 1,
                    "pincode": pincode
                },
                config
            );

            console.log('Add to cart response:', response.data);
            setAddedToCart(String(productId));
            setTimeout(() => setAddedToCart(null), 3000);
            try {
                await fetchProfile();
            } catch (profileError) {
                console.error('Failed to refetch profile data:', profileError);
            }
            
        } catch (error) {
            console.error("Failed to add to cart:", error);
            showToast({ message: 'Failed to add item to cart. Please try again.' });
        } finally {
            const elapsed = Date.now() - startedAt;
            const delay = Math.max(0, MIN_LOADER_MS - elapsed);
            if (delay > 0) {
                setTimeout(() => setAddingToCart(null), delay);
            } else {
                setAddingToCart(null);
            }
        }
    };

    const handleAddToWishlist = async (product, event) => {
        event.stopPropagation(); // Prevent navigation when clicking wishlist button
        const startedAt = Date.now();
        const productId = product.id;

        try {
            setAddingToWishlist(productId);

            const isGuest = localStorage.getItem('guestUser') === 'true';
            if (isGuest) {
                const guestWishlist = JSON.parse(localStorage.getItem('guestWishlist') || '[]');
                const exists = guestWishlist.some((item) => String(item.product_id) === String(productId));
                if (!exists) {
                    const wishItem = {
                        _id: `guest-wish-${Date.now()}-${productId}`,
                        product_id: productId,
                        urls: product.urls || [],
                        title: product.title || 'Product',
                        price: product.price,
                        brand: product.brand,
                        mrp: product.mrp,
                        selectedSize: 'M'
                    };
                    guestWishlist.push(wishItem);
                    localStorage.setItem('guestWishlist', JSON.stringify(guestWishlist));
                }
                setAddedToWishlist(String(productId));
                setTimeout(() => setAddedToWishlist(null), 3000);
                setAddingToWishlist(null);
                return;
            }

            const token = localStorage.getItem("token");
            if (!token) {
                setAddingToWishlist(null);
                return;
            }

            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };

            const response = await axios.post(
                `/products/wish-list/${productId}`,
                { "selectedSize": "M" },
                config
            );

            console.log('Add to wishlist response:', response.data);
            setAddedToWishlist(String(productId));
            setTimeout(() => setAddedToWishlist(null), 3000);
            try {
                await fetchProfile();
            } catch (profileError) {
                console.error('Error refetching profile:', profileError);
            }
        } catch (error) {
            console.error('Failed to add to wishlist:', error);
            if (error.response?.status === 400) {
                setAddedToWishlist(String(productId));
                setTimeout(() => setAddedToWishlist(null), 3000);
            }
        } finally {
            const elapsed = Date.now() - startedAt;
            const delay = Math.max(0, MIN_LOADER_MS - elapsed);
            if (delay > 0) {
                setTimeout(() => setAddingToWishlist(null), delay);
            } else {
                setAddingToWishlist(null);
            }
        }
    };

    return (
        <div className="product-slider-multi-web">
            {
                slides?.map(({ urls: images, id, title, price, brand, mrp }, index) => {
                    const discount = (mrp != null && price != null && mrp > 0) ? Math.round((1 - price / mrp) * 100) : 0;
                    return (
                        <div className="slide-main" onClick={() => navigate(`specific/${id}`)}>
                            <div className='slide-container'>
                                {
                                    isHover === index ? (
                                        <div className="multi-container" onMouseOver={() => handleDelayChange(images.length)} onMouseLeave={() => unsetHover()} style={isHover === index ? { display: 'block' } : { display: 'none', transition: 'none' }}>                                        
                                            <>
                                                <div className="main-multi">
                                                    {console.log('called multi')}                                                    
                                                    <div className="multi-slide" style={swichSlides}>                                                       
                                                        {
                                                            images.map((image) => {
                                                                return (
                                                                    <div>
                                                                        <img src={image} />
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                        <div>
                                                            <img src={images?.[0]} />
                                                        </div>
                                                    </div>

                                                    <ul className="slick-smalldots">                                                       
                                                        {
                                                            images.map((image, index) => {
                                                                return (
                                                                    <li className={activeSmalldots === index ? 'slick-active' : ''}>
                                                                        <button>{index+1}</button>
                                                                    </li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                </div>

                                                <div className="meta-data">
                                                    <div className="product-option-container">
                                                        <span className="product-option">
                                                            <span 
                                                                className={`add-to-cart ${addingToCart === id ? 'is-loading' : ''} ${addedToCart === String(id) ? 'is-added' : ''}`}
                                                                onClick={(e) => handleAddToCart({ id, urls: images, title, price, brand, mrp }, e)}
                                                                style={{ 
                                                                    cursor: addingToCart === id ? 'not-allowed' : 'pointer',
                                                                    opacity: addingToCart === id ? 0.8 : 1
                                                                }}
                                                            >                                                                
                                                                {addingToCart === id ? (
                                                                    <span className="product-option-loader" aria-hidden />
                                                                ) : addedToCart === String(id) ? (
                                                                    <IoCheckmark />
                                                                ) : (
                                                                    <IoCartOutline/>
                                                                )}
                                                            </span>
                                                            <span 
                                                                className={`add-to-wishlist ${addingToWishlist === id ? 'is-loading' : ''} ${addedToWishlist === String(id) ? 'is-added' : ''}`}
                                                                onClick={(e) => handleAddToWishlist({ id, urls: images, title, price, brand, mrp }, e)}
                                                                style={{ 
                                                                    cursor: addingToWishlist === id ? 'not-allowed' : 'pointer',
                                                                    opacity: addingToWishlist === id ? 0.8 : 1
                                                                }}
                                                            >                                                                
                                                                {addingToWishlist === id ? (
                                                                    <span className="product-option-loader" aria-hidden />
                                                                ) : addedToWishlist === String(id) ? (
                                                                    <IoCheckmark />
                                                                ) : (
                                                                    < HeartImg />
                                                                )}
                                                            </span>                                                            
                                                        </span>
                                                    </div>
                                                    <div className="brand">{brand ?? '—'}</div>
                                                    <div className="offer-details">
                                                        {price != null && <span>Rs. {price}</span>}
                                                        {mrp != null && mrp > 0 && <span>Rs. {mrp}</span>}
                                                        {discount > 0 && <span>({discount}% OFF)</span>}
                                                    </div>
                                                </div>
                                            </>


                                        </div>

                                    )
                                        :
                                        (
                                            <div className="main-single" onMouseEnter={() => setIsHover(index)} style={isHover !== index ? { display: 'block' }
                                                : { display: 'none', transition: 'none' }} onMouseLeave={() => setIsHover(index)}>
                                                {console.log('called single')}

                                                <>
                                                    <div className="ratings-container">
                                                        <span>4.2</span>
                                                        <span>*</span>
                                                        <div className="product-ratingsCount">
                                                            <div className="product-seperator">|</div>
                                                            4.2K
                                                        </div>
                                                    </div>
                                                    <div className="single-slide">
                                                        <img src={newTag} />
                                                        <img src={images?.[0]} />
                                                    </div>

                                                    <div className="meta-data">
                                                        <div className="brand">{brand ?? '—'}</div>
                                                        <div className="title">{title ?? 'Product'}</div>
                                                        <div className="offer-details">
                                                            {price != null && <span>Rs. {price}</span>}
                                                            {mrp != null && mrp > 0 && <span>Rs. {mrp}</span>}
                                                            {discount > 0 && <span>({discount}% OFF)</span>}
                                                        </div>
                                                    </div>
                                                </>
                                                {/* } */}

                                            </div>
                                        )
                                }
                            </div>
                        </div>
                    )
                })

                // <div className="slide-main">
                //     {
                //         slides.map((order) => {
                //             return (
                //                 <div>{order.title}</div>
                //             )
                //         })
                //     }
                // </div>
            }
        </div>
    )
}